
/* styles */
require("!!vue-style-loader!css-loader?sourceMap!./../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-400f40ce&scoped=true!stylus-loader!./../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./Empty.vue")

var Component = require("!./../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./../../../node_modules/vue-loader/lib/selector?type=script&index=0!./Empty.vue"),
  /* template */
  require("!!./../../../node_modules/vue-loader/lib/template-compiler?id=data-v-400f40ce!./../../../node_modules/vue-loader/lib/selector?type=template&index=0!./Empty.vue"),
  /* scopeId */
  "data-v-400f40ce",
  /* cssModules */
  null
)
Component.options.__file = "/app/src/components/Main/Empty.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] Empty.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (module.hot) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-400f40ce", Component.options)
  } else {
    hotAPI.reload("data-v-400f40ce", Component.options)
  }
})()}

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/Main/Empty.vue
// module id = 158
// module chunks = 0